export enum AUTH_ACTIONS {
    'USER_LOGGED_IN',
    'USER_LOGGED_OUT',
}
